import React from 'react';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import { tags_partner } from '../../../utils/query-helpers';

export default function useQuery(props) {
  const {
    network,
    pagination = {},
    params = {}
  } = props;

  return useConnect('user.find', {
    where: {
      eager: {
        $where: {
          networkId: network?.id,
          ...tags_partner(),
          ...params
        }
      }
    },
    ...pagination
  }, {
    keepPreviousData: true
  });
}
